import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import { ScrollElement } from "./ScrollElement";
import still from './ChartScroll.module.css'

const useStyles = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: 'black',
      fontSize: '16px',
      fontWeight: 600,
      
    },
  }));

export const ChartScroll = ({
    line,
    setLine,
    hendleMutateData
}) => {

    const classes = useStyles()
    const unicId = (id) => `line-${id}`
    
    return (
        <div className={still.scroll}>
            <Grid
                container
                spacing={3}
                direction={"row"}
            >   
                {
                    line.map((ln, index) =>  
                        <Grid item className={classes.paper} key={unicId(index)} xs={12}> 
                            <ScrollElement 
                                dataKey={ln.dataKey}
                                stroke={ln.stroke} 
                                type={ln.type}
                                setLine={setLine}
                                hendleMutateData={hendleMutateData}
                            />
                        </Grid>
                    )
                }
            </Grid>
        </div>
    );
}